/**
 * URL safety utilities — validates and normalizes URLs to prevent
 * XSS via javascript:/data:/vbscript:/blob: schemes and open redirects
 * via protocol-relative URLs.
 */

export const isSafeUrl = (value) => {
    if (!value) return false;
    const v = value.trim().toLowerCase();
    if (/^(javascript|data|vbscript|blob)\s*:/i.test(v)) return false;
    if (v.startsWith("//")) return false;
    return true;
};

export const isExternalLink = (value) => {
    if (!value) return false;
    const v = value.toLowerCase().trim();
    return (
        v.startsWith("http://") ||
        v.startsWith("https://") ||
        v.startsWith("www.") ||
        /^[a-z0-9-]+\.[a-z]{2,}/.test(v)
    );
};

export const normalizeLink = (value) => {
    if (!value || !isSafeUrl(value)) return "";
    if (isExternalLink(value)) {
        if (!value.startsWith("http")) {
            return "https://" + value;
        }
        return value;
    }
    return value.startsWith("/") ? value : "/" + value;
};
